import { formatDate } from "@angular/common";
import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OtpVerifyComponent } from "src/app/shared-modules/otp-verify/otp-verify.component";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-userscustomer-view",
  templateUrl: "./admin-userscustomer-view.component.html",
  styleUrls: ["./admin-userscustomer-view.component.css"],
})
export class AdminUserscustomerViewComponent implements OnInit {
  customerData: any;
  editCustomerProfile: boolean = false;
  customerProfile: boolean = true;
  editCustomerFrom: FormGroup;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  file: any = "";
  loading: boolean = false;
  otp_verify: boolean = false;
  truckowner_verify_otp: boolean = false;
  otp_ver: boolean = false;
  otpWrongErrorMsg: boolean = false;
  verify_otp: boolean = false;
  otpVerify: boolean = false;
  ismobileVerified: boolean = false;
  truckImage: any;
  token: any;
  id: any;
  otpCode: any;
  loginResponse: any;
  perPage: any = 10;
  startPage: any = 1;
  minDob = new Date();
  public invalidDob: boolean = false;
  public mobileVerified = 0;
  editing: boolean = false;

  constructor(
    private matdialogref: MatDialogRef<AdminUserscustomerViewComponent>,
    private matDialog: MatDialog,
    private services: AdminService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.customerData = this.data;
    this.token = localStorage.getItem("adminToken");
    this.editCustomerFrom = this.formBuilder.group({
      username: ["", Validators.required],
      nick: ["", [Validators.required]],
      mobile: ["", [Validators.required]],
      dob: ["", [Validators.required]],
      company_name: ["", [Validators.required]],
      designation: ["", [Validators.required]],
      gender: ["", [Validators.required]],
      name: ["", [Validators.required]],
      email: [""],
      company: ["", [Validators.required]],
      landmark: ["", [Validators.required]],
      city: ["", [Validators.required]],
      state: ["", [Validators.required]],
      pincode: ["", [Validators.required]],
      gst: ["", [Validators.required]],
      address_line: ["", [Validators.required]],
      area_name: ["", [Validators.required]],
      billing_email: [""],
      billing_mobile: ["", [Validators.required]],
      s9_margin: [0, [Validators.required, Validators.min(0)]],
      s9_workorder_bidding_timer: [0, [Validators.required, Validators.min(0)]],
      bid_visibility: [false]
    });
    this.fetchInitialData();
    var year = this.minDob.getFullYear() - 18;
    let returnData = this.formatFormDate(new Date(`12/31/${year}`));
    this.minDob = new Date(returnData);
  }
  fetchInitialData(): void {
    const response = { mobile_verified: 1 };
    this.mobileVerified = response.mobile_verified;
    this.ismobileVerified = this.mobileVerified === 1;
    if (this.customerData.user_type === 'corporate' &&
      (this.customerData.userInfo[0]?.s9_margin === undefined ||
        this.customerData.userInfo[0]?.s9_margin === null)) {
      this.customerData.userInfo[0].s9_margin = 0;
    }
    if (this.customerData.user_type === 'corporate' &&
      (this.customerData.userInfo[0]?.s9_workorder_bidding_timer === undefined ||
        this.customerData.userInfo[0]?.s9_workorder_bidding_timer === null)) {
      this.customerData.userInfo[0].s9_workorder_bidding_timer = 0;
    }
    if (this.customerData.user_type === 'corporate' && this.customerData.userInfo[0]?.bid_visibility === undefined) {
      this.customerData.userInfo[0].bid_visibility = false;
    }
  }
  close() {
    this.matdialogref.close();
  }

  public formatFormDate(date: Date) {
    return formatDate(date, "yyyy-MM-dd", "en");
  }
  customerGet() {
    this.services
      .getUsersCustomer(this.token, this.perPage, this.startPage)
      .subscribe(
        (response: any) => {
          const customerdata = response.body.data;
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public onDateChnage(num: number) {
    if (num === 2 && this.editCustomerFrom.value.dob > this.today) {
      this.invalidDob = true;
    }
  }
  onChange(event: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.truckImage = response.body.image_link;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  editUserCustomer() {
    this.editing = true;
    this.ismobileVerified = false;
    this.editCustomerProfile = true;
    this.customerProfile = false;
    this.truckImage = this.customerData.userInfo[0]?.profile_pic;
    this.editCustomerFrom.patchValue({
      username: this.customerData.username,
      mobile: this.customerData.mobile,
      dob: this.customerData.userInfo[0]?.dob,
      company_name: this.customerData.userInfo[0]?.company_name,
      gender: this.customerData.userInfo[0]?.gender,
      email: this.customerData?.email,
      ...(this.customerData.user_type === 'corporate' && {
        s9_margin: this.customerData.userInfo[0]?.s9_margin,
        s9_workorder_bidding_timer: this.customerData.userInfo[0]?.s9_workorder_bidding_timer ?? 0,
        bid_visibility: this.customerData.userInfo[0]?.bid_visibility ?? false
      }),
      name: this.customerData?.username,
      billing_email: this.customerData.userInfo[0]?.billing_address?.email,
      address_line:
        this.customerData.userInfo[0]?.billing_address?.address_line,
      area_name: this.customerData.userInfo[0]?.billing_address?.area_name,
      city: this.customerData.userInfo[0]?.billing_address?.city,
      state: this.customerData.userInfo[0]?.billing_address?.state,
      pincode: this.customerData.userInfo[0]?.billing_address?.pincode,
      billing_mobile: this.customerData.userInfo[0]?.billing_address?.mobile,
      gst: this.customerData.userInfo[0]?.billing_address?.gst,
      landmark: this.customerData.userInfo[0]?.landmark,
    });
  }

  public Otpsend(): void {
    if (!this.editCustomerFrom.controls["mobile"].valid) {
      this.editCustomerFrom.controls["mobile"].markAsTouched();
      return;
    }
    const dataValue = {
      mobile: this.editCustomerFrom.value.mobile,
      displayText: "Mobile Number",
      from: "userCustomer",
      user_type: this.data.user_type || "",
      ref_id: this.data.ref_id,
    };
    let matDialogref = this.matDialog.open(OtpVerifyComponent, {
      width: "500px",
      data: {
        dataKey: dataValue,
      },
    });
    matDialogref.afterClosed().subscribe((res: any) => {
      if (res.event === "Success") {
        this.mobileVerified = 1;
        this.ismobileVerified = true;
      }
    });
  }

  preventNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'e') {
      event.preventDefault();
    }
  }

  updateUser() {
    if (this.mobileVerified !== 1) {
      this.snackBar.open("Please Verify mobile number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let email = this.editCustomerFrom.value.email;

    // Email validation using regex only if the email field is not empty
    if (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        this.snackBar.open("Please enter a valid email", "Fail", {
          duration: 5000,
        });
        return;
      }
    }
    const billingObj = {
      username: this.editCustomerFrom.value.name,
      email: this.editCustomerFrom.value.billing_email,
      address_line: this.editCustomerFrom.value.address_line,
      area_name: this.editCustomerFrom.value.area_name,
      city: this.editCustomerFrom.value.city,
      state: this.editCustomerFrom.value.state,
      pincode: this.editCustomerFrom.value.pincode,
      mobile: Number(this.editCustomerFrom.value.billing_mobile),
      gst: this.editCustomerFrom.value.gst,
      landmark: this.editCustomerFrom.value.landmark,
      gst_verified:
        this.customerData.userInfo[0]?.billing_address?.gst_verified === true ||
        this.customerData.userInfo[0]?.billing_address?.gst_verified === 1,
    };
    const customerObj = {
      username: this.editCustomerFrom.value.username,
      mobile: this.editCustomerFrom.value.mobile,
      email: this.editCustomerFrom.value.email,
      dob: this.editCustomerFrom.value.dob,
      gender: this.editCustomerFrom.value.gender,
      company_name: this.editCustomerFrom.value.company_name,
      profile_pic: this.truckImage,
      designation: this.customerData.userInfo[0]?.designation,
      billing_address: billingObj,
      ...(this.customerData.user_type === 'corporate' && {
        s9_margin: Number(this.editCustomerFrom.value.s9_margin),
        s9_workorder_bidding_timer: Number(this.editCustomerFrom.value.s9_workorder_bidding_timer),
        bid_visibility: this.editCustomerFrom.value.bid_visibility
      }),
    };
    // this.id = localStorage.getItem("userCustomer");
    this.services
      .customerUpdate(customerObj, this.token, this.customerData.ref_id)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.customerGet();
            this.snackBar.open(
              "Customer details updated successfull",
              "Success",
              {
                duration: 5000,
              }
            );
            this.matdialogref.close();
            window.location.reload();
            localStorage.removeItem("userName");
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  onMobileInputChange(): void {
    if (this.editing) {
      this.mobileVerified = 0;
    }
  }

  archiveCustomer() {
    if (confirm("Are you sure you want to delete this customer?")) {
      this.loading = true;
      this.services.archiveCustomer(this.token, this.customerData.ref_id).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status >= 200 && response.status < 300) {
            this.snackBar.open(response.body.message, "Success", {
              duration: 5000,
            });
            this.matdialogref.close();
            window.location.reload();
          } else {
            this.snackBar.open("Failed to delete customer", "Fail", {
              duration: 5000,
            });
          }
        },
        (error) => {
          this.loading = false;
          let errorMsg = "Failed to delete customer";
          if (error.error && error.error.message) {
            errorMsg = error.error.message;
          }

          if (errorMsg === "jwt malformed" || errorMsg === "jwt expired" || errorMsg === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }

          this.snackBar.open(errorMsg, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }
}
